import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { slug: String, state: String }
  static targets = [
    "username", "publicKey", "goodbillPgpKey",
    "rotateModal", "pgpModal", "removePgpModal"
  ]

  copyValue(event) {
    event.stopPropagation()
    const text = event.currentTarget.dataset.copyText
    if (!text) return
    this._copyToClipboard(text, event.currentTarget)
  }

  copyUsername(event) {
    event.stopPropagation()
    if (!this.hasUsernameTarget) return
    this._copyToClipboard(this.usernameTarget.textContent.trim(), event.currentTarget)
  }

  copyPublicKey(event) {
    event.stopPropagation()
    if (!this.hasPublicKeyTarget) return
    this._copyToClipboard(this.publicKeyTarget.textContent.trim(), event.currentTarget)
  }

  downloadPublicKey(event) {
    event.stopPropagation()
    if (!this.hasPublicKeyTarget) return
    const blob = new Blob([this.publicKeyTarget.textContent.trim()], { type: "text/plain" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${this.slugValue}.pub`
    a.click()
    URL.revokeObjectURL(url)
  }

  copyGoodbillPgpKey(event) {
    event.stopPropagation()
    if (!this.hasGoodbillPgpKeyTarget) return
    this._copyToClipboard(this.goodbillPgpKeyTarget.textContent.trim(), event.currentTarget)
  }

  downloadGoodbillPgpKey(event) {
    event.stopPropagation()
    if (!this.hasGoodbillPgpKeyTarget) return
    const blob = new Blob([this.goodbillPgpKeyTarget.textContent.trim()], { type: "text/plain" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "goodbill-public.asc"
    a.click()
    URL.revokeObjectURL(url)
  }

  showRotateModal() {
    if (this.hasRotateModalTarget) {
      this.rotateModalTarget.classList.remove("hidden")
    }
  }

  hideRotateModal() {
    if (this.hasRotateModalTarget) {
      this.rotateModalTarget.classList.add("hidden")
    }
  }

  showPgpUploadModal(event) {
    event.stopPropagation()
    if (this.hasPgpModalTarget) {
      this.pgpModalTarget.classList.remove("hidden")
    }
  }

  hidePgpUploadModal() {
    if (this.hasPgpModalTarget) {
      this.pgpModalTarget.classList.add("hidden")
    }
  }

  showRemovePgpModal(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.hasRemovePgpModalTarget) {
      this.removePgpModalTarget.classList.remove("hidden")
    }
  }

  hideRemovePgpModal() {
    if (this.hasRemovePgpModalTarget) {
      this.removePgpModalTarget.classList.add("hidden")
    }
  }

  _copyToClipboard(text, button) {
    const originalHTML = button.innerHTML
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        this._showCopySuccess(button, originalHTML)
      }).catch(() => {
        this._fallbackCopy(text, button, originalHTML)
      })
    } else {
      this._fallbackCopy(text, button, originalHTML)
    }
  }

  _fallbackCopy(text, button, originalHTML) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.left = "-999999px"
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand("copy")
      this._showCopySuccess(button, originalHTML)
    } catch (_e) {
      // silent fail
    }
    document.body.removeChild(textArea)
  }

  _showCopySuccess(button, originalHTML) {
    button.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8l3 3 7-7"/></svg>'
    button.style.color = "#1E9D7C"
    setTimeout(() => {
      button.innerHTML = originalHTML
      button.style.color = ""
    }, 1500)
  }
}
